export default "__VITE_ASSET__BwtiAjrj__"